<template>

  <img src="/static/img/header.png" style="margin:-36px 0px 37px -27px;width: 105%;" class="bnr" />

  <div class="row">
    <div class="col-md-4">
      <div class="authenticate">
        <h2 style="font-weight: initial;background: #202e6d; color: white;text-transform:initial;">Log in</h2>
        <div class="wrap-fluid" style="margin-left: 0px !important;">
          <div class="row">
            <div class="col-lg-12">
              <div class="account-box">
                <div id="login">
                  <div style="margin-bottom:20px;">
                    <div class='form-group'>
                      <label style="font-weight:initial;">Username</label>
                      <input
                        type="text"
                        name="username"
                        v-model="input.username"
                        placeholder="Username"
                        class="form-control"
                      />
                    </div>

                    <div class='form-group'>
                      <label style="font-weight:initial;">Password</label>
                      <input
                        type="password"
                        name="password"
                        v-model="input.password"
                        placeholder="Password"
                        class="form-control"
                      />
                    </div>
                  </div>
                  
                  <div class="">
                    <div class="" style="text-align:right;">
                      <button type="button" v-on:click="login()" class=""
                        style="text-transform: uppercase; width: 100px; height: 40px; color: white; background: #202e6d; outline: none; border: none; margin-bottom: 10px;"
                      >Log in</button>
                      <br />
                      <a href="/register">
                        <button type="button" v-on:click="" class=""
                        style="text-transform:none;width: 100px;height:40px;color:#202e6d;background:white;outline:none;border:solid 1px #202e6d;"
                        >Register</button>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-8">
      <div class="authenticate display-card">
        <div class='text-half' style="padding:30px;display:inline-block;width:49%;">
          <h2 style="color:black;border:none;padding:0px;">Predict your ferments with powerful data analysis</h2>

          <p>
            Powerful algorithms match the ferment curve from your data as it is collected, enabling forward prediction of how your ferment will end.
          </p>

          <p>
            Access the ferment simulator from anywhere, at any time.
          </p>
        </div>
        <div class="img-half" style="display:inline-block;width:49%;">
          <img src="/static/img/fermentsimgraphic.png" style="max-width:100%;" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
ol {
  font-size: 16px;
}

ol li {
  margin-bottom: 8px;
}

li.disabled {
  opacity: 0.3;
}

li.active {
  font-weight: 700;
}

.authenticate .wrap-fluid {
  margin-left: 0px !important;
}

.authenticate h2 {
  font-size: 17px;
  padding-left: 40px;
}

#login input[type='text'], #login input[type='password'] {
  width: 75%;
}

#login .form-group {
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: right;
}

#login label {
  margin-right: 10px;
}

.authenticate .wrap-fluid {
  padding: 25px 35px 0px 35px;
}

#login .form-group {
  margin-bottom: 25px;
}

.text-half, .img-half {
  vertical-align: middle;
}

.text-half h2 {
  text-transform: initial;
  font-size: 25px;
  margin-bottom: 30px;
  line-height: 32px;
}

.display-card {
  padding: 50px 15px 30px 15px;
}

.text-half p {
  font-size: 14px;
  color: black;
}

@media(max-width: 767px){
  .display-card {
    text-align: center;
    padding: 0px 15px 30px 15px;
  }

  .bnr {
    width: 200% !important;
    margin: -36px 0px 37px -195px !important;
    margin-left: -50% !important;
  }

  .form-group {
    text-align: center !important;
  }
  
  .login-wrp{
    display: none !important;
  }

  #login {
    text-align: center;
  }
}

@media(max-width: 1200px){
  .text-half {
    width: 100% !important;
  }

  .display-card {
    text-align: center;
  }
}

</style>

<script>
import {
  Sites as SiteActions,
  App as AppActions,
  User as UserActions,
} from "vx/actions";
import Alert from "utils/alert";
import { config } from "../../config";

export default {
  name: "Login",
  data() {
    return {
      input: {
        username: "",
        password: "",
      },
      authenticating: false,
    };
  },

  vuex: {
    actions: {
      setTitle: AppActions.title,
      selectSite: SiteActions.select,
      authenticateLocally: UserActions.authenticateLocally,
    },
  },

  ready() {
    this.setTitle("Login");

    // Login may be redirected to unexpectedly via the auth checking, so we ensure any loading anim is always terminated
    this.$dispatch('loaded');
  },

  methods: {
    gotoSiteSelection() {
      this.$router.go({ name: "site-selection.index" });
    },

    backToWineCloud(
      text = "Sorry, but you are unauthorized to access this application. We will now redirect you back to WineCloud."
    ) {
      Alert.error({ title: "Unauthorized!", text }).then(() => {
        window.location = config.WC_PATH;
      });
    },
    login() {

      this.$dispatch('loading');

      if (this.input.username != "" && this.input.password != "") {
        this.authenticating = true;

        this.authenticateLocally(this.input.username, this.input.password).then(
          (response) => {
            this.authenticating = false;
            this.gotoSiteSelection();
          },
          (response) => {
            this.$dispatch('loaded');
            this.authenticating = false;
            let message = response.body.message;
            Alert.error({ title: "Unauthorized!", text: message });
          }
        );
      } else {
        this.$dispatch('loaded');
        Alert.error({
          title: "Error!",
          text: "A username and password must be present",
        });
      }
    },
  },
};
</script>
<!--
<style scoped>
#login {
  width: 500px;
  border: 1px solid #cccccc;
  background-color: #ffffff;
  margin: auto;
  margin-top: 200px;
  padding: 20px;
}
</style>
-->



// WEBPACK FOOTER //
// login.vue?a9621c10